"use client";

import {Anchor, Button, Group, Popover, ScrollArea, Stack} from "@mantine/core";
import {FaqFile} from "@/app/(layout)/faq/faq-utils";
import {sanitizeQuestion} from "@/app/(layout)/faq/sanitize-question";
import {useMobile} from "@/components/common/hooks/responsive-utils";

export function FaqMenu({faqFiles}: { faqFiles: FaqFile[] }) {
    const isMobile = useMobile();
    return (
        <Group gap={'xs'} wrap={isMobile ? 'wrap' : 'nowrap'}>
            {faqFiles.map(({section, faqs}) => (
                <Popover
                    key={section}
                    withArrow
                    withinPortal={false}
                    shadow={'xl'}
                    closeOnClickOutside
                    closeOnEscape
                    position="bottom"
                    transitionProps={{transition: 'pop-top-right'}}
                >
                    <Popover.Target>
                        <Button variant={'subtle'} size={'compact-md'}>
                            {section}
                        </Button>
                    </Popover.Target>
                    <Popover.Dropdown bg={'var(--mantine-color-body)'} w={'auto'}>
                        <ScrollArea.Autosize mah={200} type={'always'} scrollbars={'y'}>
                            <Stack gap={'xs'}>
                                {faqs.map(({question}) => {
                                    const q = sanitizeQuestion(question);
                                    return (
                                        <Anchor key={q} href={`#${q}`}>{question}</Anchor>
                                    );
                                })}
                            </Stack>
                        </ScrollArea.Autosize>
                    </Popover.Dropdown>
                </Popover>
            ))}
        </Group>
    )
}
